export function sanitizeUrl(url: string): string {
  let sanitizedUrl = url;

  sanitizedUrl = sanitizedUrl.replace(/([^:]\/)\/+/g, '$1');

  if (url.endsWith('/')) {
    sanitizedUrl = sanitizedUrl.slice(0, -1);
  }

  return sanitizedUrl;
}
